import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getBlogListDetail = createAsyncThunk('getBlogStatistics',
    
    async (object, { dispatch, getState }) => {
        const {userToken}= checkAuthorization()
        dispatch(gettingAddBlogDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/getAllBlogs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(addblogDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(addblogDetailClear())
                message.error(error) 
            })
    }
)

export const getBlogCategory = createAsyncThunk('getBlogCategoryStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingAddBlogDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/getBlogCategory`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(blogCateResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(blogCateClear())
                message.error(error) 
            })
    }
)

export const getBlogRecentPost = createAsyncThunk('getBlogPostStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingAddBlogDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/getRecentBlogs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(blogPostResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(blogPostClear())
                message.error(error) 
            })
    }
)

export const getBlogPopularPost = createAsyncThunk('getBlogPopularStatistics',
    async (object, { dispatch, getState }) => {
        dispatch(gettingAddBlogDetail())
        var myHeaders = new Headers();
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl + `/popularBlogs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(blogPopularResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(blogPopularClear())
                message.error(error) 
            })
    }
)



const BlogGetAllSlice = createSlice({
    name: 'bloglistapi',
    initialState: {
        bloglistData: null,
        loadingblogDetail: false,
        blogcateData: null,
        recentpostData: null,
        popularpostData: null,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
        },
    },
    reducers: {
        gettingAddBlogDetail: state => {
            state.loadingblogDetail=true
            state.bloglistData=null
        },
        addblogDetailResponse: (state, action)=>{
            state.bloglistData= action.payload
            state.loadingblogDetail= false
        },
        addblogDetailClear: (state)=>{
            state.bloglistData= null
            state.loadingblogDetail= false
        },
        changeBlogDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        blogCateResponse: (state, action)=>{
            state.blogcateData= action.payload
            state.loadingblogDetail= false
        },
        blogCateClear: (state)=>{
            state.blogcateData= null
            state.loadingblogDetail= false
        },
        blogPostResponse: (state, action)=>{
            state.recentpostData= action.payload
            state.loadingblogDetail= false
        },
        blogPostClear: (state)=>{
            state.recentpostData= null
            state.loadingblogDetail= false
        },
        blogPopularResponse: (state, action)=>{
            state.popularpostData= action.payload
            state.loadingblogDetail= false
        },
        blogPopularClear: (state)=>{
            state.popularpostData= null
            state.loadingblogDetail= false
        },
    },
})
export const { 
    gettingAddBlogDetail, addblogDetailResponse, addblogDetailClear,
    changeBlogDetailFilters, setPages, blogCateResponse, blogCateClear,
    blogPostResponse,blogPostClear, blogPopularResponse, blogPopularClear
} = BlogGetAllSlice.actions;
export default BlogGetAllSlice.reducer;